/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ApiParameter, request } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/invoice/PDF";

export interface GetInvoiceNumberApiParameter extends ApiParameter {
    invoiceNumber: string;
}

export function getInvoicePDF(parameter: GetInvoiceNumberApiParameter) {
    const invoiceNumber = parameter.invoiceNumber;

    return request<any>(`${apiUrl}/${invoiceNumber}`, "GET", {
        "Content-Type": "application/pdf",
    }).then((response: any) => {
        return {
            apiUrl: `${apiUrl}/${invoiceNumber}`,
            invoices: response.invoices
        }
    });
}
